import { useState, useEffect, useCallback } from 'react';
import API from 'api/api';
import { useFirebaseAuth } from 'domains/auth/hooks/useFirebaseAuth';

export default function useFetchApprovedTrucks() {
  const { uid } = useFirebaseAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchApprovedTrucks = useCallback(async () => {
    if (!uid) return;

    setLoading(true);
    try {
      const res = await API.get(`/users/${uid}/trucks/approved`);
      setData(res.data?.data || []); // { data: [...] } from controller
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [uid]);

  useEffect(() => {
    fetchApprovedTrucks();
  }, [uid, fetchApprovedTrucks]);

  return { data, loading, error, refetch: fetchApprovedTrucks };
}
